import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import { FloatingChatButtonStyle, FloatingChatTooltipWrapper, FloatingChatTooltipContent } from "./Styles";
import AIChatBotGif from "../../../assets/svg/teammate-ai.gif";

const { Text } = Typography;

const FloatingChatButton = ({ onClick, isVisible = true, isActive = false }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  if (!isVisible) {
    return null;
  }

  return (
    <FloatingChatTooltipWrapper>
      <FloatingChatTooltipContent isHovered={isHovered}>
        <Text strong style={{ fontSize: "14px", fontFamily: '"Open Sans", sans-serif' }}>
          {t("ai_chat_bot.chat_bot_name")}
        </Text>
        <Text style={{ fontSize: "12px", fontFamily: '"Open Sans", sans-serif' }}>
          {t("ai_chat_bot.intro_panel.how_can_i_help")}
        </Text>
      </FloatingChatTooltipContent>
      <FloatingChatButtonStyle
        onClick={onClick}
        isActive={isActive}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img src={AIChatBotGif} alt="AI Chat Bot" style={{ width: "50px", height: "50px", flexShrink: 0 }} />
      </FloatingChatButtonStyle>
    </FloatingChatTooltipWrapper>
  );
};

export { FloatingChatButton };
